<div class="orders-container p-2">
  
  <!-- Empty State -->
  <div *ngIf="orders.length === 0" class="empty-orders-state">
    <div class="empty-icon-wrap">
      <i class="bx bx-shopping-bag"></i>
    </div>
    <h3>No Orders Found</h3>
    <p>Looks like you haven't placed any orders yet.</p>
  </div>

  <!-- Orders List -->
  <div *ngFor="let order of paginatedOrders" class="order-card-premium" [class.is-open]="order.open">
    
    <!-- HEADER -->
    <div class="order-header-premium" (click)="order.open = !order.open">
      <div class="left-info">
        <div class="order-code">Order #{{order.order_code}}</div>
        <div class="order-date">
          {{order.ordered_at | date:'mediumDate'}} at {{order.ordered_at | date:'shortTime'}}
        </div>
      </div>

      <div class="right-info">
        <button class="btn-premium-invoice" (click)="downloadInvoice(order.order_id); $event.stopPropagation()">
          <i class="bx bx-download"></i>
          <span>Invoice</span>
        </button>
        <span
          class="status-badge"
          [ngClass]="{
            'status-pending': order.tracking_status === 'Pending',
            'status-shipped':
              order.tracking_status === 'Shipment Created'
              ||
              order.tracking_status === 'Dispatched'
              ||
              order.tracking_status === 'Shipped',
            'status-delivered': order.tracking_status === 'Delivered'
          }">
          {{ order.tracking_status }}
        </span>
        <span class="total-amount">₹{{order.order_total}}</span>
        <span class="toggle-icon">
          <i class="bx" [class.bx-chevron-up]="order.open" [class.bx-chevron-down]="!order.open"></i>
        </span>
      </div>
    </div>

    <!-- ITEMS (Collapsible) -->
    <div class="order-body-premium" *ngIf="order.open">
      <div *ngFor="let item of order.items" class="item-row-premium">
        <img [src]="item.item_image" class="item-img-premium" alt="Product Image">
        <div class="item-details-premium">
          <div class="item-name">{{item.item_name}}</div>
          <div class="item-meta">
            ₹{{item.item_price}} × {{item.quantity}}
          </div>
        </div>
        <div class="item-total-premium">₹{{item.item_total}}</div>
      </div>

      <div class="order-footer-premium">
        <button
          class="btn-track-premium"
          (click)="openTracking(order); $event.stopPropagation()">
          <i class="bx bx-map-pin"></i> Track Order
        </button>
        <button class="btn-reorder-premium">
          <i class="bx bx-refresh"></i> Reorder
        </button>
      </div>
    </div>

  </div>

  <!-- PAGINATION CONTROLS -->
  <div class="pagination-container" *ngIf="orders.length > pageSize">
    <button class="page-btn prev-btn" (click)="prevPage()" [disabled]="currentPage === 1">
      <i class="bx bx-chevron-left"></i> Prev
    </button>
    <div class="page-numbers">
      <button 
        *ngFor="let page of pagesArray" 
        class="page-number-btn" 
        [class.active]="currentPage === page" 
        (click)="setPage(page)">
        {{page}}
      </button>
    </div>
    <button class="page-btn next-btn" (click)="nextPage()" [disabled]="currentPage === totalPages">
      Next <i class="bx bx-chevron-right"></i>
    </button>
  </div>

</div>

<!-- TRACKING MODAL -->
<div
  class="tracking-modal-premium"
  *ngIf="showTrackingModal"
  (click)="closeTracking()">

  <div
    class="tracking-content-premium"
    (click)="$event.stopPropagation()">

    <div class="tracking-header-premium">
      <div>
        <h3>Track Shipment</h3>
        <p class="tracking-code-sub">Order #{{ selectedOrder?.order_code }}</p>
      </div>
      <button class="close-btn-premium" (click)="closeTracking()">
        <i class="bx bx-x"></i>
      </button>
    </div>

    <div class="tracking-progress-premium">

  <!-- Order Placed -->
  <div class="step-wrapper">
    <div class="step active">
      <i class="bx bx-check"></i>
    </div>
    <span class="step-label">Order Placed</span>
  </div>

  <!-- Line 1 -->
  <div
    class="progress-line"
    [class.active]="
      selectedOrder?.tracking_status === 'Dispatched' ||
      selectedOrder?.tracking_status === 'Shipped' ||
      selectedOrder?.tracking_status === 'Delivered'
    ">
  </div>

  <!-- Dispatched -->
  <div class="step-wrapper">
    <div
      class="step"
      [class.active]="
        selectedOrder?.tracking_status === 'Dispatched' ||
        selectedOrder?.tracking_status === 'Shipped' ||
        selectedOrder?.tracking_status === 'Delivered'
      ">
      <i class="bx bx-send"></i>
    </div>
    <span class="step-label">Dispatched</span>
  </div>

  <!-- Line 2 -->
  <div
    class="progress-line"
    [class.active]="
      selectedOrder?.tracking_status === 'Shipped' ||
      selectedOrder?.tracking_status === 'Delivered'
    ">
  </div>

  <!-- Shipped -->
  <div class="step-wrapper">
    <div
      class="step"
      [class.active]="
        selectedOrder?.tracking_status === 'Shipped' ||
        selectedOrder?.tracking_status === 'Delivered'
      ">
      <i class="bx bx-package"></i>
    </div>
    <span class="step-label">Shipped</span>
  </div>

  <!-- Line 3 -->
  <div
    class="progress-line"
    [class.active]="
      selectedOrder?.tracking_status === 'Delivered'
    ">
  </div>

  <!-- Delivered -->
  <div class="step-wrapper">
    <div
      class="step"
      [class.active]="
        selectedOrder?.tracking_status === 'Delivered'
      ">
      <i class="bx bx-home-smile"></i>
    </div>
    <span class="step-label">Delivered</span>
  </div>

</div>

    <div class="tracking-details-premium">
      <div class="detail-row-premium">
        <span class="detail-lbl">Current Status</span>
        <span class="detail-val status-text">{{ selectedOrder?.tracking_status }}</span>
      </div>

      <div class="detail-row-premium" *ngIf="selectedOrder?.awb_code">
        <span class="detail-lbl">AWB Number</span>
        <span class="detail-val text-selectable">{{ selectedOrder?.awb_code }}</span>
      </div>

      <div class="detail-row-premium" *ngIf="selectedOrder?.courier_name">
        <span class="detail-lbl">Courier Partner</span>
        <span class="detail-val">{{ selectedOrder?.courier_name }}</span>
      </div>

      <div class="detail-row-premium">
        <span class="detail-lbl">Order Date</span>
        <span class="detail-val">{{ selectedOrder?.ordered_at | date:'medium' }}</span>
      </div>
    </div>

  </div>
</div>
